import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { setAuthenticated } from 'modules/auth';

import { $apiV2 } from '../service';
import { globalConst, setUser } from '..';

export const useLoginWithTelegram = () => {
  const t = useTranslations();
  const { replace, push } = useRouter();
  const dispatch = useAppDispatch();
  const isAuth = useAppSelector(({ user }) => user?.phone);

  return useMutation({
    mutationFn: async ({ hashCode }: { pathname?: string; hashCode?: string }) => {
      dispatch(setAuthenticated({ status: false, loading: true }));
      const { data } = await $apiV2.post(`/auth/login-with-telegram`, { hashcode: hashCode });

      return data;
    },
    onSuccess: async (data, variables) => {
      const { pathname } = variables;

      dispatch(setAuthenticated({ status: true, loading: false }));
      dispatch(setUser(data?.data));
      replace({ pathname }, undefined, { shallow: true });
    },
    onError: (_, { pathname }) => {
      const isOlympic = pathname === globalConst.pageNames.ONLINE_OLYMPIC;

      message.error(
        t('bu_tokenning_muddati_tugagan', {
          type: isOlympic ? t('turnirga_otish') : t('profilga_otish')
        })
      );
      if (pathname === globalConst.pageNames.ONLINE_OLYMPIC) {
        push(pathname);
      } else if (isAuth) {
        push(pathname || '/');
      } else {
        push('/');
      }
      dispatch(setAuthenticated({ status: true, loading: false }));
    }
  });
};
